import { call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { CreateOfferAsyncActions } from 'store/actions/createOffer';
import { apiCall } from 'utils/apiCall';
import { toast } from 'react-toastify';
import routes from 'containers/App/routeConstants';

function* updateState(action) {
  const {
    UpdateState: {
      Actions: { SUCCESS, FAILURE },
    },
  } = CreateOfferAsyncActions;
  const {
    payload: { offerId, status, comment },
  } = action;

  try {
    const response = yield call(apiCall, `/offers/${offerId}/${status}`, 'put', { comment });
    yield put(SUCCESS(response.data));
    if (status === 'BUYER_REJECTED') {
      yield put(push(routes.HOME_PATH));
    }
  } catch (error) {
    toast.error(error.message);
    yield put(FAILURE(error));
  }
}

export default updateState;
